import { render } from "./preloadProductComponent.vue?vue&type=template&id=7c016f56"
import script from "./preloadProductComponent.vue?vue&type=script&lang=js"
export * from "./preloadProductComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__